import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import muiTheme from '../../theme/muiTheme';
import './searchBar.css'
import SearchBarReact from './searchBarReact';

const SearchBar = ({ embedded = false } = {}) => {
    return (
        // <ThemeProvider theme={muiTheme}>
        //     <CssBaseline />
        //     <SearchBarMUI />
        // </ThemeProvider>
        <ThemeProvider theme={muiTheme}>
            <CssBaseline />
            <SearchBarReact embedded={embedded} />
        </ThemeProvider>
    );
}

export default SearchBar